import { render } from "./Secondary3.vue?vue&type=template&id=e2d887d0&ts=true"
import script from "./Secondary3.vue?vue&type=script&lang=ts"
export * from "./Secondary3.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/assets/images/avatars/Secondary3.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e2d887d0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e2d887d0', __exports__)) {
    api.reload('e2d887d0', __exports__)
  }
  
  module.hot.accept("./Secondary3.vue?vue&type=template&id=e2d887d0&ts=true", () => {
    api.rerender('e2d887d0', render)
  })

}


export default __exports__